import { Button } from "@result/rui/components";
import { useNotifications } from "@result/rui/hooks";
import React from "react";
import { useTranslation } from "react-i18next";

import ApiClient from "#/redux/api/ApiClient";

export default function TemplateDownloadButton({
  downloadPath,
  templateFileName = "template.csv",
  downloadButtonLabel = "import.download-template-file",
}) {
  const { t } = useTranslation();
  const { addErrorNotification } = useNotifications();

  // download file from the API endpoint and trigger download in the browser
  const handleDownload = async () =>
    ApiClient.getFile(downloadPath)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", templateFileName); // use templateFileName for filename
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch(({ response: { data } }) => {
        addErrorNotification(data?.details, data?.message);
      });
  return (
    <Button
      label={t(downloadButtonLabel)}
      color="white"
      leftIcon="icon-download"
      onClick={handleDownload}
      isDisabled={!downloadPath}
    />
  );
}
